import {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import FetchList from './FetchList';
import NoItems from '../../commonSub/component/NoItems';
import useChangeWebviewTermsTitle from '../../more/hook/useChangeWebviewTermsTitle';
import FoldableListItemV4 from '../component/FoldableListItemV4';
import useTypedSelector from '../hook/useTypedSelector';
import {actions, ActionType} from '../state/action';
import {INoticeType} from '../type';

interface IProps {
  type: INoticeType;
  id?: number;
  isWebview?: boolean;
  space?: number;
  focusId?: number;
  title?: string;
  onClickItem?: (isOpened: boolean) => void;
}

export default function NoticeV4({
  type,
  id,
  isWebview,
  space = 0,
  focusId,
  title,
  onClickItem,
}: IProps) {
  const dispatch = useDispatch();
  const [openedId, setOpenedId] = useState<number | undefined>();
  const [noticeList] = useTypedSelector(state => [state.common.noticeList]);

  useEffect(() => {
    dispatch(actions.fetchNoticeList({id, type}, true));

    return () => {
      dispatch(actions.setValue('noticeList', []));
    };
  }, [dispatch, type, id]);

  const requestGetNextList = () => {
    dispatch(actions.fetchNoticeList({id, type}));
  };

  useEffect(() => {
    setOpenedId(
      noticeList.find(({id}) => id === focusId)?.id || noticeList[0]?.id
    );
  }, [focusId, noticeList]);

  // TODO : 작품홍 > 공지사항 개편 후 삭제
  useEffect(() => {
    document.body.classList.remove('bg-background', 'bg-background-02');
    document.body.classList.add('bg-background-02');
  }, []);

  useChangeWebviewTermsTitle(title);

  return (
    <div
      className={cn('lg-max:mx-11', {
        'mt-10': !isWebview && noticeList.length,
      })}
    >
      <FetchList
        actionType={ActionType.FetchNoticeList}
        fetchKey={type}
        items={noticeList}
        requestGetNextList={requestGetNextList}
        noRowsRenderer={() => (
          <NoItems textKey="notification_notice_list_blank" />
        )}
        itemClassName="mt-8 first:mt-0 last:pb-32"
      >
        {index => {
          const item = noticeList[index];

          return (
            <FoldableListItemV4
              key={index}
              title={item.title}
              subText={item.agoText}
              contents={item.contents}
              setIsOpened={(isOpened: boolean) => {
                setOpenedId(isOpened ? item.id : undefined);
              }}
              isOpened={openedId === item.id}
              space={space}
              onClickItem={onClickItem}
            />
          );
        }}
      </FetchList>
    </div>
  );
}
